module.exports = __webpack_public_path__ + "static/media/emoji_smiling_sunglasses.0327add9.svg";